import React, { useEffect, useState } from 'react';
import discountIcon from '../../media/discount.png'; // your icon
import axios from 'axios';
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

export default function CouponBlock({
  setSelectedCoupon,
  cartTotal = 0,
  onApply, // optional callback (coupon) => void
}) {
    const [coupons, setCoupons]= useState([])
  const [isListOpen, setIsListOpen] = useState(false);
  const [couponInput, setCouponInput] = useState('');
  const [error, setError] = useState('');

  const openList = () => setIsListOpen(true);
  const closeList = () => setIsListOpen(false);

  const handleApplyFromList = (coupon) => {
    // Basic min order validation before applying
    if (coupon.minOrder && cartTotal < coupon.minOrder) {
      setError(
        `Minimum order ₹${coupon.minOrder} required for ${coupon.code}. Your total is ₹${cartTotal}.`
      );
      return;
    }
    setError('');
    setCouponInput(coupon.code);
    closeList();
    setSelectedCoupon(coupon)
  };

  const handleManualApply = () => {
    const found = coupons.find((c) => c.code.toUpperCase() === couponInput.trim().toUpperCase());
    if (!found) {
      setError('Invalid coupon code.');
      return;
    }
    if (found.minOrder && cartTotal < found.minOrder) {
      setError(
        `Minimum order ₹${found.minOrder} required for ${found.code}. Your total is ₹${cartTotal}.`
      );
      return;
    }
    setError('');
    onApply?.(found);
    // You can show a toast or success state here if you like
  };

  const fetchCoupons = async () => {
        try {
            const response = await axios.get(`${adminUrl}/getCoupons`);
            setCoupons(response.data || []);
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    };
    useEffect(()=>{
        fetchCoupons();
    },[])
  return (
    <div className="coupan-code">
      <div className="input" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          type="text"
          name="coupan-code"
          placeholder="Enter coupon code"
          value={couponInput}
          onChange={(e) => setCouponInput(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="button" onClick={handleManualApply} className="btn btn-apply">
          Apply
        </button>
      </div>

      {error && (
        <div style={{ color: '#c0392b', fontSize: 12, marginTop: 6 }}>
          {error}
        </div>
      )}

      <div
        className="coupans-available"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          marginTop: 10,
          position: 'relative',
        }}
      >
        <img src={discountIcon} alt="" />
        {coupons.length} Coupons Available
        {/* Bootstrap 5 uses float-end instead of pull-right */}
        <button
          type="button"
          onClick={openList}
          className="float-end"
          style={{
            marginLeft: 'auto',
            fontWeight: 700,
            color: '#5f5b57',
            textDecorationLine: 'underline',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          View All
        </button>
      </div>

      {/* Simple modal/drawer for coupon list */}
      {isListOpen && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={closeList}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.35)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 16,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: 480,
              background: '#fff',
              borderRadius: 0,
              padding: 16,
              boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
              <h4 style={{ margin: 0, fontWeight: 700 }}>Available Coupons</h4>
              <button
                type="button"
                onClick={closeList}
                aria-label="Close"
                style={{
                  marginLeft: 'auto',
                  border: 'none',
                  background: 'transparent',
                  fontSize: 18,
                  cursor: 'pointer',
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ display: 'grid', gap: 10, maxHeight: 320, overflowY: 'auto' }}>
              {coupons.map((c) => (
                <div
                  key={c.code}
                  style={{
                    border: '1px dashed #dcdcdc',
                    borderRadius: 0,
                    padding: 12,
                    display: 'grid',
                    gap: 6,
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span
                      style={{
                        fontWeight: 700,
                        fontFamily: 'monospace',
                        background: '#f6f6f6',
                        padding: '2px 6px',
                        borderRadius: 4,
                      }}
                    >
                      {c.code}
                    </span>
                    <span style={{ color: '#5f5b57', fontSize: 13 }}>{c.description}</span>
                  </div>
                  <div style={{ color: '#7f8c8d', fontSize: 12 }}>
                    {c.minOrder ? `Min order ₹${c.minOrder}` : 'No minimum'} ·
                    {' '}Expires {new Date(c.expiresAt).toLocaleDateString()}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button
                      type="button"
                      onClick={() => handleApplyFromList(c)}
                      className="btn btn-sm btn-apply"
                    >
                      Apply
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        navigator.clipboard?.writeText(c.code);
                      }}
                      className="btn btn-sm btn-outline-secondary"
                    >
                      Copy Code
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: 12, textAlign: 'right' }}>
              <button type="button" onClick={closeList} className="btn btn-light">
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
